// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Context = require("../../../../provider/Context.bs.js");
var Atom_Cta = require("../../../atom/Atom_Cta.bs.js");
var Atom_Row = require("../../../atom/Atom_Row.bs.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("../../../particle/Particle_Screen_Ds.bs.js");
var Organism_BurgerMenu = require("./Organism_BurgerMenu.bs.js");

function Organism_BaseNavigation(Props) {
  var menuNavigation = Props.menuNavigation;
  var category = Props.category;
  var desktopNavigation = Props.desktopNavigation;
  var country = Props.country;
  var logoNavigation = Props.logoNavigation;
  var searchState = Props.searchState;
  var logoBerne = Props.logoBerne;
  var match = Context.I18n.getState(undefined);
  var match$1 = match.labels.navbar;
  var displayMobileRules = searchState ? Particle_Screen_Ds.make(undefined, undefined, "inlineFlex", undefined, undefined, "none") : Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "none");
  var burgerMenuDisplay = searchState ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex") : Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "none");
  var tmp = {
    menuNavigation: menuNavigation,
    display: burgerMenuDisplay
  };
  if (category !== undefined) {
    tmp.category = Caml_option.valFromOption(category);
  }
  var tmp$1;
  if (country) {
    var __x = desktopNavigation.links;
    tmp$1 = React.createElement(React.Fragment, undefined, Belt_Array.map(Js_array.filter((function (param) {
                    return param.id !== "search";
                  }), __x), (function (param) {
                var id = param.id;
                var tmp = id === "concert" ? ({
                      TAG: /* Header */10,
                      _0: {
                        TAG: /* Concert */1,
                        _0: /* Default */1
                      }
                    }) : ({
                      TAG: /* Header */10,
                      _0: /* BaseNavigation */0
                    });
                return React.createElement(Atom_Cta.Link.make, {
                            href: param.href,
                            label: param.label,
                            style: tmp,
                            key: id
                          });
              })));
  } else {
    tmp$1 = React.createElement(React.Fragment, undefined, Belt_Array.map(logoNavigation.links, (function (param) {
                var id = param.id;
                var tmp = id === "concert" ? ({
                      TAG: /* Header */10,
                      _0: {
                        TAG: /* Concert */1,
                        _0: /* Europe */0
                      }
                    }) : ({
                      TAG: /* Header */10,
                      _0: /* BaseNavigation */0
                    });
                return React.createElement(Atom_Cta.Link.make, {
                            href: param.href,
                            label: param.label,
                            style: tmp,
                            key: id
                          });
              })));
  }
  return React.createElement(React.Fragment, undefined, React.createElement(Atom_Row.make, {
                  children: null,
                  rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.position(CssJs.unset)])
                }, React.createElement(Atom_Cta.Link.make, {
                      href: logoNavigation.href,
                      screenReadersLabel: logoNavigation.title,
                      style: {
                        TAG: /* Header */10,
                        _0: {
                          TAG: /* Logo */7,
                          _0: /* Vertical */1,
                          _1: logoBerne,
                          _2: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inlineFlex")
                        }
                      }
                    }), React.createElement(Organism_BurgerMenu.make, tmp)), React.createElement(Atom_Row.make, {
                  children: tmp$1,
                  display: displayMobileRules,
                  kind: {
                    TAG: /* Nav */10,
                    _0: match$1.secondaryNavigation
                  }
                }));
}

var make = Organism_BaseNavigation;

exports.make = make;
/* CssJs Not a pure module */
